import { comapanyNameToClass } from "../../common/helper";
import CompanyLogo from "../../components/CompanyLogo/CompanyLogo";
import "../../pages/styles/navbar.scss";

const DocOnlineNavbar = ({ candidacyCompany, height }) => {
  return (
    <div className={`navbar ${comapanyNameToClass(candidacyCompany)}`}>
      <div className="leftmost">
        <div className="logo">
          <CompanyLogo
            company={candidacyCompany}
            height={candidacyCompany === "Codewin"  ? height="70px" : height="40px"}
            width="auto"
            alt="logo"
          />
        </div>
      </div>
    </div>
  );
};

export default DocOnlineNavbar;
